import { IEnumeration } from 'utility-js-enumeration';

declare var Enumeration: IEnumeration;

const notificationSetting = {
  PUSH: 'PUSH',
  TEXT: 'TEXT',
  EMAIL: 'EMAIL'
};

angular
  .module('capability-ng-notification-settings')
  .constant('notificationSetting', Enumeration('notificationSetting', notificationSetting));



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/constants/notification_setting.ts